import { useQuery } from '@tanstack/react-query';
import { getDormantSummary, listDormantSoftware } from './api';
import { dormancyKey } from './key';
import type { DormantSoftwareQuery } from './type';
export const useDormantSummary = () => {
  return useQuery({
    queryKey: dormancyKey.summary(),
    queryFn: getDormantSummary,
    staleTime: 5 * 60 * 1000
  });
};
export const useDormantSoftware = (params: DormantSoftwareQuery) => {
  return useQuery({
    queryKey: dormancyKey.list(params),
    queryFn: () => listDormantSoftware(params),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false
  });
};